import { render, staticRenderFns } from "./TransactionAmount.vue?vue&type=template&id=2dbf6cce&"
import script from "./TransactionAmount.vue?vue&type=script&lang=ts&"
export * from "./TransactionAmount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports